import { render, staticRenderFns } from "./ProductionPerformanceDetail.vue?vue&type=template&id=698f6970"
import script from "./ProductionPerformanceDetail.vue?vue&type=script&lang=js"
export * from "./ProductionPerformanceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports